import { api } from './api';

export interface Suppression {
  id: string;
  email: string;
  reason: string;
  createdAt: string;
}

/** Workspace do-not-contact list (deliverability guardrails). */
export const suppressionsApi = {
  list: async (workspaceId: string): Promise<Suppression[]> => {
    const r = await api.get<Suppression[]>(`/api/workspaces/${workspaceId}/suppressions`);
    return r.data;
  },
  add: async (workspaceId: string, email: string): Promise<void> => {
    await api.post(`/api/workspaces/${workspaceId}/suppressions`, { email, reason: 'manual' });
  },
  remove: async (workspaceId: string, id: string): Promise<void> => {
    await api.delete(`/api/workspaces/${workspaceId}/suppressions/${id}`);
  },
};
